module.exports = __webpack_public_path__ + "static/media/sre-returned.aa3018ca.svg";